import React, { useMemo, useState } from "react";
import { Package } from "@phosphor-icons/react";
import { brl } from "../lib/format";
import LazyImage from "./LazyImage";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
const FILTERS = [["all", "Todos"], ["paid", "Pagos"], ["pending", "A pagar"]];

export default function LiveGallery({ orders }) {
  const [filter, setFilter] = useState("all");

  const cards = useMemo(() => {
    const map = new Map();
    orders.filter(o => !o.withdrawn && (filter === "all" || (filter === "paid" ? o.paid : !o.paid))).forEach(o => {
      const key = (o.product_code || "").trim() || o.id;
      const c = map.get(key) || { key, code: o.product_code, description: o.description, photoOrder: null, qty: 0, total: 0, paidQty: 0, pendingQty: 0 };
      const q = o.quantity || 1;
      c.qty += q;
      c.total += (o.price || 0) * q;
      if (o.paid) c.paidQty += q; else c.pendingQty += q;
      if (!c.photoOrder && o.has_photo) c.photoOrder = o.id;
      map.set(key, c);
    });
    return [...map.values()].sort((a, b) => b.total - a.total);
  }, [orders, filter]);

  const visible = cards;
  const totalQty = visible.reduce((s, c) => s + c.qty, 0);
  const totalValue = visible.reduce((s, c) => s + c.total, 0);

  return (
    <div data-testid="live-gallery" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-2">
          {FILTERS.map(([k, label]) => (
            <button key={k} data-testid={`gallery-filter-${k}`} onClick={() => setFilter(k)}
              className={`btn-brutal h-10 !px-4 text-xs ${filter === k ? "bg-brand-pink text-white" : "bg-white text-brand-ink"}`}>
              {label}
            </button>
          ))}
        </div>
        <p data-testid="gallery-summary" className="font-bold text-sm">{totalQty} peça(s) · {brl(totalValue)}</p>
      </div>
      {visible.length === 0 ? (
        <div className="card-brutal p-10 text-center bg-brand-cream font-bold">Nenhuma peça para mostrar.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {visible.map(c => <GalleryCard key={c.key} c={c} />)}
        </div>
      )}
    </div>
  );
}

function GalleryCard({ c }) {
  return (
    <div data-testid={`gallery-card-${c.code}`} className="card-brutal bg-white overflow-hidden flex flex-col transition-transform hover:-translate-y-1">
      <div className="aspect-square bg-brand-cream border-b-2 border-brand-ink flex items-center justify-center overflow-hidden">
        {c.photoOrder
          ? <LazyImage src={`${API_BASE}/api/orders/${c.photoOrder}/photo?w=400`} alt={c.description} className="w-full h-full" />
          : <Package weight="bold" size={40} className="opacity-30" />}
      </div>
      <div className="p-3 text-sm space-y-1 flex-1">
        <p className="font-bold truncate">{c.code}</p>
        <p className="text-brand-ink2 text-xs truncate" title={c.description}>{c.description}</p>
        <p className="flex items-center justify-between pt-1">
          <span className="badge-brutal bg-brand-cream !text-[10px]">×{c.qty}</span>
          <span className="font-black">{brl(c.total)}</span>
        </p>
        <p className="flex flex-wrap gap-1 pt-1">
          {c.paidQty > 0 && <span className="badge-brutal bg-brand-mint !text-[10px]">{c.paidQty} pago</span>}
          {c.pendingQty > 0 && <span className="badge-brutal bg-red-600 text-white !text-[10px]">{c.pendingQty} a pagar</span>}
        </p>
      </div>
    </div>
  );
}
